import md5 from 'md5';
import moment from 'moment'
import {find} from 'lodash'
import {message} from 'ant-design-vue'
import router from '@/app-routing'
import {util,enterStatus,buzzType,http,$http, cookies,enterType} from './index'
import {portalApi} from './api'
import store from '@store'
import {isLeYou} from '@/shared/utils/constant'
class Jump {
    /**
     * 登录
     */
    login(name = ''){
        router.push({name: isLeYou? 'lylogin':'login', query: {linkName: name || ''}})
    }
    /**
     * 注册
     */
    register(){
        router.push({name:'register'})
    }
    /**
     * 退出
     */
    async logout(name = ''){
        await $http.get(portalApi.logout);
        util.clearCookies();
        if (name) {
            this.login(name)
        } else {
            this.home();
        }
    }
    /**
     * 退出登录返回到指定连接
     */
    async logoutRefer({link,name}){
        await http.get(portalApi.logout);
        util.clearCookies();
        if(link){
            location.href = link
        } else if(name) {
            router.push({name})
        } else {
            this.home();
        }
    }
    /**
     * 商家工作台
     */
    async preWorkbench(fun){
        const ensureLogin =  util.ensureLogin('workbench');
     
        
        if(ensureLogin) {
            let userInfo = store.state.userInfo;
            if(!userInfo) {
                userInfo = await store.dispatch('getUserInfo');
            }
            if(userInfo && (userInfo.enterStatus == enterStatus.BIND /*|| userInfo.fatherId*/)) {//已入驻或子账号可进入商家工作台
                let link = ''
                switch (+userInfo.buzzType) {
                    case buzzType.POP: 
                    case buzzType.GLOBALBUY: 
                        const popToken = userInfo.key || ''
                        const {sellerLink, seller} = await util.getPartnerLink();
                        if (seller.newPlatform) {
                            link = seller.platformUrl
                        } else {
                            link = `${sellerLink}/popAuthLogin/login4Portal.do?popToken=${popToken}`;//pop-全球购
                        }
                        break;
                    case buzzType.BRANDMERCHANT:
                    case buzzType.PROPRIETARY: 
                    case buzzType.FRANCHISEE:
                        const {partnerLink, partner} = await util.getPartnerLink();
                        if (partner.newPlatform) {
                            link = partner.platformUrl
                        } else {
                            link = `${partnerLink}/view/new-main.jsp`;//协同平台 
                        }
                        break;
                    case buzzType.YUER: 
                        const {yuer} = await util.getPartnerLink();
                        if (yuer.newPlatform) {
                            link = yuer.platformUrl
                        } else {
                            link = '//ygj.haiziwang.com'
                        }
                        // link = '//ygj.haiziwang.com'
                        // link = `//seller.czj100.com/sync/checkLogin?bid=${bid}&token=${token}`//大服务商家
                        break;
                    case buzzType.CZJ: 
                        // const bid = userInfo.buzzId;
                        // const date = moment().format("YYYY-MM-DD");
                        // const token = md5(`${date}VNVaWYqND14${bid}`)
                        const { czj } = await util.getPartnerLink();
                        if (czj.newPlatform) {
                            link = czj.platformUrl
                        } else {
                            link = '//ygj.haiziwang.com'
                        }
                        // link = `//seller.czj100.com/sync/checkLogin?bid=${bid}&token=${token}`//大服务商家
                        break;
                    case buzzType.ADVERTISER:
                        link = '//open.haiziwang.com/pages/advertiser'
                        break
                }
                if(link) {
                    location.href = link;
                }        
            } else {
                fun()
            }
        }
    }
    workbench(){
        this.preWorkbench(()=>{
            this.enterManage();
        })
    }
    /**
     * 首页
     */
    home(){
        try{
            if(router.history.current.name != 'home'){
                router.push({name:'home'})
            } else {
                location.reload(true);
            }
        } catch(e){
            router.push({name:'home'})
        }
    }
    /**
     * 平台服务管理
     */
    serveManage(){
        router.push({name:'serveManage'})
    }
    /**
     * 账号入驻合作状态管理
     */
    enterManage(){
        try{
            if(router.history.current.name != 'enterManage'){
                router.push({name:'enterManage'})
            }
        } catch(e){
            router.push({name:'enterManage'})
        }
    }
    /**
     * 账号入驻合作状态管理--商家编码绑定
     */
    accountBindCode(){
        const ensureLogin =  util.ensureLogin('accountBindCode');
        if(ensureLogin) {
            try{
                if(router.history.current.name != 'accountBindCode'){
                    router.push({name:'accountBindCode'})
                }
            } catch(e){
                router.push({name:'accountBindCode'})
            }         
        }    
    }
    /**
     *绑定页面前置 
     */
    async preAccountBindCode(callBack){
        console.log(232323)
        let userInfo = store.state.userInfo;
        if(!userInfo) {
            userInfo = await store.dispatch('getUserInfo');
        }
        if(userInfo.enterStatus == enterStatus.BIND) {
            this.enterManage();
        } else {
            callBack()
        }
    }
    /**
     * 关闭当前页
     */
    closeCurrent(){
        this.home()
    }
    /**
     * 入驻进度
     */
    enterProgress(){
        const userInfo = store.state.userInfo;
        const cmsInfo = store.state.pages.home.cmsHome || {}
        const enterData = cmsInfo.enterData || {}
        if(userInfo && userInfo.buzzType) {
            const settleInType = +userInfo.settleInType
            const settled = (enterData.settled_list || []).find(x => +x.purpose === settleInType)
            // console.log(settleInType, settled, enterData.settled_list)
            if (settled && settled.progressUrl) {
                location.href = settled.progressUrl
            } else {
                location.href = `//zhaoshang.haiziwang.com/enter-progress/${userInfo.settleInType ||userInfo.buzzType}`
            }
        }
    }

    //继续入驻
    async goOnEnter(purpose, item) {
        location.href = item.url;
        // const response = await http.get('//bpc.haiziwang.com/api/v2/apply/check',{
        //     params:{purpose},
        //     credentials: 'include',
        //     withCredentials: true
        // })
        // if(response && response.code == 1001 && response.data && response.data.form_status){
        //     const form_status = response.data.form_status;
        //     const obj = find(form_status,o =>o.status != 1);
        //     if(obj && obj.type) {
        //         location.href = `${item.url}/${obj.type}`;
        //     } else {
        //         location.href = item.url;
        //     }
        // } else {
        //     location.href = item.url;
        // }
    }
    /**
     * 账号管理
     */
    accoutManage(){
        const userInfo = store.state.userInfo;
        if(userInfo && (userInfo.buzzType == buzzType.CZJ || userInfo.buzzType == buzzType.YUER)){
            router.push({name:'account-list4CZJ'})
        } else {
            router.push({name:'account-list'})
        }
        
    }
    /**
     * 安全管理
     */
    safeManage(){
        router.push({name:'safe-manage'})
    }

    toEnter() {
        router.push({name: 'enter'})
    }
}

export const jump = new Jump()
